import React from 'react';
import type { ResolvedProps } from 'Cms/tour-program/resolver';
import 'Cms/tour-program/resolver';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { ProductProgram } from 'Components/widgets/product-program/ProductProgram';
type Props = ResolvedProps & {
  id?: string;
};
export const TourProgramLine = ({ id, ...props }: Props) => {
  const { stopover = {} } = props;
  const { tour = {}, extension = {} } = stopover;
  return (
    <SiteContainer className="Line" id={id}>
      <ProductProgram
        isDetailed={props.isDetailed}
        extension={{
          stops: extension.stops,
          subtitle: extension.duration,
          title: extension.title,
        }}
        program={{
          stops: tour.stops,
          subtitle: tour.duration,
          title: tour.title,
        }}
      />
    </SiteContainer>
  );
};
